export default __webpack_public_path__ + "static/Plots0022-f23efdda4dcf470a41e4c62ec8117c68.jpg";